<template>
  <el-row>
    <el-col :span="12">
      <el-form-item label="单位" prop="Unit">
        <el-input v-model.trim="value.Unit" size="small" />
      </el-form-item>
      <el-form-item label="最大值" prop="MaxValue">
        <el-input v-model.trim="value.MaxValue" size="small" />
      </el-form-item>
      <el-form-item label="超出时异常文本" prop="OutRangeInfo">
        <el-input v-model.trim="value.OutRangeInfo" size="small" />
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="精度" prop="Precision">
        <el-input v-model.trim="value.Precision" size="small" />
      </el-form-item>
      <el-form-item label="最小值" prop="MinValue">
        <el-input v-model.trim="value.MinValue" size="small" />
      </el-form-item>
      <el-form-item label="其他异常文本" prop="ContentException">
        <el-input v-model.trim="value.ContentException" size="small" />
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    props: {
      value: Object,
    },
  };
</script>
